import { useModals } from "@/router"

export default function CharteUtilisation() {

    const modals = useModals()

    const handleClose = () => modals.close()

    return (
    <div className="fixed inset-0 place-items-center bg-black/25 md:mt-[72px] md:ml-64 md:p-10 overflow-auto z-50">
      
      <div className="relative flex w-full md:max-w-5xl flex-col rounded-lg border border-slate-500 bg-white p-10">
        
        <h1 className="text-3xl font-bold mb-6">Charte d’utilisation du forum interne</h1>

        <section className="mb-8">
            <h2 className="text-xl font-semibold mb-2">1. Objectif du forum</h2>
            <p>
                Le forum interne est un espace de discussion réservé aux participants de la finale nationale <strong>Worldskills France</strong>.<br />
                Il permet de faciliter les échanges, le partage d’informations et la coordination des actions.
            </p>
        </section>

        <section className="mb-8">
            <h2 className="text-xl font-semibold mb-2">2. Accès et confidentialité</h2>
            <ul className="list-disc list-inside space-y-1">
                <li>L’accès au forum est <strong>strictement réservé</strong> aux membres autorisés disposant d’un compte personnel.</li>
                <li>Les échanges sur le forum sont <strong>confidentiels</strong> et ne doivent pas être partagés à l’extérieur de l&apos;association sans autorisation.</li>
                <li>Chaque utilisateur s’engage à utiliser une adresse email valide et à jour.</li>
            </ul>
        </section>

        <section className="mb-8">
            <h2 className="text-xl font-semibold mb-2">3. Comportement attendu</h2>
            <ul className="list-disc list-inside space-y-1">
                <li>Respecter les autres participants, leurs idées et leurs opinions</li>
                <li>Adopter un ton courtois et bienveillant</li>
                <li>Ne pas publier de messages discriminants, violents, diffamatoires ou contraires aux lois en vigueur</li>
                <li>Ne pas diffuser d&apos;informations mensongères ou non vérifiées</li>
                <li>Utiliser le forum dans un but associatif uniquement (pas de promotion personnelle ou commerciale)</li>
            </ul>
        </section>

        <section className="mb-8">
            <h2 className="text-xl font-semibold mb-2">4. Publications et contenu</h2>
            <ul className="list-disc list-inside space-y-1">
                <li>Chaque message publié engage la responsabilité de son auteur</li>
                <li>Les messages doivent être clairs, utiles et en lien avec les thématiques abordées</li>
                <li>Les contenus inappropriés pourront être supprimés par les modérateurs.</li>
            </ul>
        </section>

        <section className="mb-8">
            <h2 className="text-xl font-semibold mb-2">5. Modération</h2>
            <p>L’équipe de modération (désignée par Worldskills France) veille au bon fonctionnement du forum. Elle peut :</p>
            <ul className="list-disc list-inside space-y-1 mt-2">
                <li>Supprimer/Modifier un message</li>
                <li>Rappeler un utilisateur à l’ordre</li>
                <li>Suspendre un compte en cas de non-respect de la charte</li>
            </ul>
            <p className="mt-2">En cas de problème, les utilisateurs sont invités à signaler les contenus inappropriés ou à contacter l’équipe de modération ou le webmaster du forum à l&apos;adresse <strong>forum@worldskills-france.org</strong>.</p>
        </section>

        <section className="mb-8">
            <h2 className="text-xl font-semibold mb-2">6. Respect de la vie privée</h2>
            <ul className="list-disc list-inside space-y-1">
                <li>Aucune donnée personnelle ne doit être publiée sans le consentement des personnes concernées.</li>
                <li>Les photos, adresses, numéros de téléphone ou tout autre renseignement personnel doivent être partagés avec discernement.</li>
            </ul>
        </section>

        <section className="mb-8">
            <h2 className="text-xl font-semibold mb-2">7. Mise à jour de la charte</h2>
            <p>Cette charte peut être modifiée à tout moment pour s’adapter à l’évolution des usages du forum ou des règles de l’association. Les utilisateurs seront informés de toute mise à jour.</p>
            </section>

            <section>
            <h2 className="text-xl font-semibold mb-2">8. Acceptation</h2>
            <p>L’accès au forum implique l’acceptation pleine et entière de cette charte. Tout comportement contraire pourra entraîner une restriction ou une suppression de l’accès au forum.</p>
        </section>
        


        <div className="mt-auto flex justify-end">
          <button className="text-sm font-semibold" onClick={() => modals.close()}>
            Fermer
          </button>
        </div>

        <div className="absolute inset-0 -z-10" onClick={handleClose} />
      </div>
    </div>
    )
}